import React, { useEffect, useState } from 'react';
import { Stripe } from '../../utils/requests'
import { useLocation, useSearchParams } from "react-router-dom";

const Success = () => {
  ///////////////////////////////////////////////////////
  // State declarations
  const [emailAddress, setEmailAddress] = useState("");
  const [openAccordion, setOpenAccordion] = useState('print');

  ///////////////////////////////////////////////////////
  // Constants
  const { state } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();  //
  const session_id = searchParams.get("session_id")

  ///////////////////////////////////////////////////////
  // Method declaration
  const setEmailFromStripeCheckoutSessionData = async (session_id) => {
    const response_json = await (await Stripe.retrieveCheckoutSessionData(session_id)).json()
    setEmailAddress(response_json.email);
  }

  useEffect( () => {
    ///////////////////////////////////////////////////////
    // Case 1 data - Free

    // If state exists, then the user was navigated to this page programmatically from the frontend
    if (state ) {
      const { email } = state; // Read values passed on state
      setEmailAddress(email);
    }

    ///////////////////////////////////////////////////////
    // Case 2 data - Paid
  
    // Got redirected from Stripe Checkout with GET parameter "session_id"
    // Fetch the session_id data from api.onwardflightticket.com

    // Testing for !emailAddress avoids multiple requests to the backend due to re-rendering
    if (session_id && !emailAddress) {
      setEmailFromStripeCheckoutSessionData(session_id);
    }
  })


  return (
    <>
        <div className="row justify-content-center mt-2">
          <div className="col-md-8 col-sm-10">
            <div className="text-center mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" fill="green" width="80" height="80" className="bi bi-check-circle mb-3" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
              </svg>
              <h2 className="text-success mb-2">Success!</h2>
              <h4 className="text-muted">
                Check your inbox: <strong>{emailAddress}</strong>
              </h4>
            </div>
          </div>
        </div>

        <div className="row justify-content-center mt-4">
          <div className="col-md-8 col-sm-10">
            <div className="card border-success">
              <div className="card-body">
                <p className="mb-3">
                  <strong>We've sent a personalized sample ticket to your e-mail address.</strong>
                </p>
                <p className="mb-0">
                  If you don't receive an email within a few minutes, it may have gone to your junk or spam mail folders by mistake. So check there first!
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* What's Next Section */}
        <div className="row justify-content-center mt-4">
          <div className="col-md-8 col-sm-10">
            <div className="card">
              <div className="card-header bg-primary text-white">
                <h5 className="mb-0">
                  <i className="bi bi-question-circle me-2"></i>
                  What's Next?
                </h5>
              </div>
              <div className="card-body">
                <div className="accordion" id="whatsNextAccordion">
                  {/* Printing tips */}
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingPrint">
                      <button 
                        className={`accordion-button ${openAccordion === 'print' ? '' : 'collapsed'}`} 
                        type="button" 
                        onClick={() => setOpenAccordion(openAccordion === 'print' ? null : 'print')}
                        aria-expanded={openAccordion === 'print'}
                        aria-controls="collapsePrint"
                      >
                        <i className="bi bi-printer me-2"></i>
                        Printing tips for best quality
                      </button>
                    </h2>
                    <div id="collapsePrint" className={`accordion-collapse collapse ${openAccordion === 'print' ? 'show' : ''}`} aria-labelledby="headingPrint">
                      <div className="accordion-body">
                        <ul>
                          <li><strong>Use A4 paper:</strong> Standard A4 (8.5" x 11") paper works best</li>
                          <li><strong>Print in color:</strong> Color printing makes the ticket look more authentic</li>
                          <li><strong>High quality:</strong> Use "Best" or "High Quality" print settings</li>
                          <li><strong>Full page:</strong> Make sure the ticket prints at 100% scale (not scaled to fit)</li>
                          <li><strong>Check alignment:</strong> Ensure all text and borders are clearly visible</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  {/* File format information */}
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingFormat">
                      <button 
                        className={`accordion-button ${openAccordion === 'format' ? '' : 'collapsed'}`} 
                        type="button" 
                        onClick={() => setOpenAccordion(openAccordion === 'format' ? null : 'format')}
                        aria-expanded={openAccordion === 'format'}
                        aria-controls="collapseFormat"
                      >
                        <i className="bi bi-file-earmark-pdf me-2"></i>
                        File format information
                      </button>
                    </h2>
                    <div id="collapseFormat" className={`accordion-collapse collapse ${openAccordion === 'format' ? 'show' : ''}`} aria-labelledby="headingFormat">
                      <div className="accordion-body">
                        <ul>
                          <li><strong>Format:</strong> PDF (Portable Document Format)</li>
                          <li><strong>Size:</strong> Optimized for printing and email</li>
                          <li><strong>Compatibility:</strong> Opens in all PDF readers (Adobe, Chrome, Firefox, etc.)</li>
                          <li><strong>Mobile:</strong> Can be viewed and printed from mobile devices</li>
                          <li><strong>Backup:</strong> Save the PDF to your phone/cloud for easy access</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row justify-content-center mt-4 mb-4">
          <div className="col-md-8 col-sm-10 text-center">
            <a type="button" className="btn btn-lg btn-primary" href="/">Create another ticket</a>
          </div>
        </div>
    </>
  )
}

export default Success
